import {
	reLocalityTypeConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reLocalityTypeConstants.GetPaged.REQUEST:
		case reLocalityTypeConstants.GetPagedAudit.REQUEST:
		case reLocalityTypeConstants.GetPagedAll.REQUEST:
		case reLocalityTypeConstants.GetList.REQUEST:
		case reLocalityTypeConstants.Create.REQUEST:
		case reLocalityTypeConstants.Delete.REQUEST:
		case reLocalityTypeConstants.Restore.REQUEST:
		case reLocalityTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reLocalityTypeConstants.GetPaged.FAILURE:
		case reLocalityTypeConstants.GetPagedAudit.FAILURE:
		case reLocalityTypeConstants.GetPagedAll.FAILURE:
		case reLocalityTypeConstants.GetList.FAILURE:
		case reLocalityTypeConstants.Create.FAILURE:
		case reLocalityTypeConstants.Delete.FAILURE:
		case reLocalityTypeConstants.Restore.FAILURE:
		case reLocalityTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reLocalityTypeConstants.GetPaged.SUCCESS:
		case reLocalityTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reLocalityTypeConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count,
				isSending  : false
			}
		case reLocalityTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reLocalityTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reLocalityTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reLocalityTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reLocalityTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reLocalityTypeConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}